import { render, staticRenderFns } from "./MailAccountConfig.yaml?vue&type=template&id=42289706&component"
import script from "./MailAccountConfig.yaml?vue&type=script&lang=ts&component"
export * from "./MailAccountConfig.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports